import { createSelector } from "reselect";
import { get, sortBy } from "sites-common/utils/lodash";
import { selectorSrcmProfile } from "gatsby-plugin-hfn-profile/state/selectors";
import { commonSelectors } from "../selector-template-generator";
import { selectorBehaveAs } from "../../state/appSelectors";

export const settingsConfig = {
  fields: [
    {
      name: "key",
      label: "Key",
    },
    { name: "value", label: "Value", type: "jsonfield" },
  ],

  collection: "CareSettings",
  primaryKey: "key",

  defaults: {},
};

export const settingsSelectors = () =>
  commonSelectors(settingsConfig.collection);

export const postprocessSettings = (r) => r;

export const validateAdmins = (/* r */) => "";

export const querySettings = () => ({
  collection: settingsConfig.collection,
  doc: "config",
});

export const saveSettings = (dbStore, payload) => {
  dbStore.setMerge(settingsConfig.collection, "config", payload).catch(() => {
    /* console.error(e) */
  });
};

export const selectorSettings = createSelector(
  (state) => state.firestore.data[settingsConfig.collection],
  selectorSrcmProfile,
  selectorBehaveAs,
  (settings, srcmProfile, behaveAs) => {
    if (!settings || !srcmProfile) {
      return { amIAdmin: false, trainersMap: {}, trainerOpts: [] };
    }
    const { config } = settings;
    if (!config) {
      return { amIAdmin: false, trainersMap: {}, trainerOpts: [] };
    }
    const who_am_i = get(srcmProfile, ["email"]);
    const name = get(srcmProfile, ["name"]);

    const behave_as = behaveAs;

    const { admins, trainersMap } = config;

    const normalizeKeys = (obj) =>
      Object.fromEntries(
        Object.entries(obj || {}).map(([k, v]) => [k.toLowerCase(), v])
      );

    // normalize all maps once
    const normalizedTrainersMap = normalizeKeys(trainersMap);
    const normalizedAdmins = normalizeKeys(admins);

    // filter + normalize
    const filteredTrainers = Object.fromEntries(
      Object.entries(normalizedTrainersMap).filter(([, v]) => v !== false)
    );

    // normalize input
    const normalizedWhoAmI = who_am_i?.toLowerCase();

    // admin check
    const i_am_admin = normalizedWhoAmI && normalizedWhoAmI in normalizedAdmins;

    // decide "who"
    const who = i_am_admin && behave_as ? behave_as : who_am_i;
    const normalizedWho = who?.toLowerCase();

    const trainerOpts = sortBy(Object.entries(filteredTrainers), ([, value]) =>
      String(value).toLowerCase()
    )
      .filter(([, value]) => value)
      .map(([, value]) => ({
        name: value,
        label: value,
      }));

    return {
      amIAdmin: normalizedWho && normalizedWho in normalizedAdmins,
      amITrainer: normalizedWho && normalizedWho in filteredTrainers,
      trainerOpts,
      filteredTrainers,
      trainer:
        (normalizedWho && normalizedTrainersMap[normalizedWho]) ||
        (normalizedWho && filteredTrainers[normalizedWho]) ||
        name,
      behave_as: who,
    };
  }
);
